/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportShipmentBaseDTO } from './etransport-shipment-base-dto.model';
import { EmailablePayloadWithContactsMapDTO } from '@well/domain';
import { ShipmentSelectableListViewVO } from '@well/delivery-libs/shipment/domain';

export class ETransportNotificationDTO extends JSONable {
  uuid: string | null = null;
  operationTypeUuid: string | null = null;
  shipmentSelectableListViewVO: ShipmentSelectableListViewVO | null = null;
  eTransportShipmentBaseDTO: ETransportShipmentBaseDTO = new ETransportShipmentBaseDTO();
  uit: string | null = null;
  externalReference: string | null = null;
  contactUuids: string[] = [];
  commercialPartnerContactUuids: string[] = [];
  shipmentOrganizerContactUuids: string[] = [];

  static mapToEmailable(
    etransportNotificationDTO: ETransportNotificationDTO
  ): EmailablePayloadWithContactsMapDTO<ETransportNotificationDTO> {
    const emailable = new EmailablePayloadWithContactsMapDTO<ETransportNotificationDTO>(ETransportNotificationDTO);
    if (etransportNotificationDTO.contactUuids) {
      emailable.contactUuids = { '': etransportNotificationDTO.contactUuids };
    }

    if (etransportNotificationDTO.eTransportShipmentBaseDTO.commercialPartnerDTO?.legalEntityUuid) {
      emailable.contactUuids = {
        ...emailable.contactUuids,
        COMMERCIAL_PARTNER: etransportNotificationDTO.commercialPartnerContactUuids?.length
          ? etransportNotificationDTO.commercialPartnerContactUuids
          : [],
      };
    }
    if (etransportNotificationDTO.eTransportShipmentBaseDTO.shipmentDataDTO?.shipmentOrganizerLegalEntityUuid) {
      emailable.contactUuids = {
        ...emailable.contactUuids,
        SHIPMENT_ORGANIZER: etransportNotificationDTO.shipmentOrganizerContactUuids?.length
          ? etransportNotificationDTO.shipmentOrganizerContactUuids
          : [],
      };
    }
    emailable.payload = etransportNotificationDTO;
    return emailable;
  }
}
